import gql from 'graphql-tag';

export default gql`
  fragment FragmentFeature on Feature {
    uId
    appId
    desc
    key
  }
`;
